/**
 * Pure logic for the content freshness engine.
 * No React, no Redux — unit-testable directly.
 */

export const GRACE_PERIOD_MS = 10000;
export const MAX_POLL_DURATION_MS = 10 * 60 * 1000; // 10 minutes
export const MAX_INTERVAL_MS = 5000;
export const ALLOWED_TYPES = ['transcoding', 'subtitle'];

// Metadata columns/fields requested for the enriched content GET. output_state
// is the media_output_workflow state (catalog column); the subtitle_* fields
// feed track labels and the Camunda progress key. file_size feeds the
// downloads list.
export const ITEM_METADATA_FIELDS = [
  'output_state',
  'subtitle_task',
  'subtitle_language',
  'subtitle_fillers',
  'file_size',
  // Downloads.jsx addresses each child by UID rather than by path, so the
  // link survives a rename. It rides on this fetch to keep the block at zero
  // API calls of its own — a folder listing does NOT include UID by default.
  'UID',
];

// Schedule: 0, 1s, 2s, 3s, 4s, 5s, 5s, 5s...
export const getInterval = (pollCount) => {
  if (pollCount === 0) return 0;
  return Math.min(pollCount * 1000, MAX_INTERVAL_MS);
};

export const isTerminalState = (state) =>
  state === 'completed' || state === 'failed';
